import axios from 'axios'

export function getVersion() {
  return axios.get(`${process.env.BASE_URL}version.txt?_=${Date.now()}`)
}
